import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const ToolList = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0;
  background: var(--background-primary);
  border: 1px solid var(--border-color);
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.025);

  @media (max-width: 720px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 480px) { grid-template-columns: 1fr; }
`;

export const ToolItem = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem 1rem;
  text-decoration: none;
  color: var(--text-primary);
  border-right: 1px solid var(--border-color);
  border-bottom: 1px solid var(--border-color);
  background: transparent;
  transition: background 0.12s ease;

  &:hover { background: var(--background-secondary); }

  &:nth-child(3n) { border-right: none; }
  &:nth-last-child(-n+3) { border-bottom: none; }

  @media (max-width: 720px) {
    &:nth-child(3n) { border-right: 1px solid var(--border-color); }
    &:nth-child(2n) { border-right: none; }
    &:nth-last-child(-n+3) { border-bottom: 1px solid var(--border-color); }
    &:nth-last-child(-n+2) { border-bottom: none; }
  }

  @media (max-width: 480px) {
    border-right: none !important;
    &:last-child { border-bottom: none; }
    &:not(:last-child) { border-bottom: 1px solid var(--border-color); }
  }
`;

export const ToolIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: var(--background-secondary);
  color: var(--text-secondary);
`;

export const ToolLabel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ToolName = styled.span`
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-primary);
`;

export const ToolHint = styled.span`
  font-size: 0.75rem;
  color: var(--text-muted);
`;

